import * as React from 'react';
import styles from './index.less';
import wrapStore from '@src/utils/wrap-store';
import FocusUsSectionStore from '@src/pages/main/components/focusUs-section/store';
import Link from '@src/components/link';
import Footer from '@src/business-components/footer';
import cx from 'classnames';
import $$tracker from '@src/tracker';
const FocusUsSection = ({ store }) => {
  store.use();
  return (
    <div className={cx(styles.focusUsRoot, store.isActive && styles.currentPage)}>
      <div className={styles.title} />
      <div className={styles.focusList}>
        {store.focusList.map(
          (item, index) =>
            item.url ? (
              <Link
                key={index}
                className={cx(styles.focusItem, store.isActive && styles.focusItemActive)}
                style={{
                  animationDelay: `${index * 0.1}s`
                }}
                href={item.url}
                target={'_blank'}
                onClick={() => {
                  $$tracker.clickGoFollow(item.name, '关注我们');
                }}
              >
                <img src={item.image} alt={item.name} />
              </Link>
            ) : (
              <div
                key={index}
                className={cx(styles.focusItem, store.isActive && styles.focusItemActive)}
                style={{
                  animationDelay: `${index * 0.1}s`
                }}
              >
                <img src={item.image} alt={item.name} />
              </div>
            )
        )}
      </div>
      <Footer store={store.footerStore} />
    </div>
  );
};

export default wrapStore(FocusUsSection, FocusUsSectionStore);
